import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const hrItemsRoutes = [
  {
    key: "hr-items",
    exact: true,
    path: `${APP_PREFIX_PATH}/hr-items`,
    component: React.lazy(() => import("views/app-views/hr-items/pages/HrItemsModule")),
  },
  {
    key: "hr-items-request",
    exact: true,
    path: `${APP_PREFIX_PATH}/hr-items/requests/:requestId`,
    component: React.lazy(() => import("views/app-views/hr-items/pages/RequestPage")),
  },
  {
    key: "hr-items-issue",
    exact: true,
    path: `${APP_PREFIX_PATH}/hr-items/issues/:issueId`,
    component: React.lazy(() => import("views/app-views/hr-items/pages/IssuePage")),
  },
  {
    key: "hr-items-history",
    exact: true,
    path: `${APP_PREFIX_PATH}/hr-items/inventory/history`,
    component: React.lazy(() => import("views/app-views/hr-items/pages/HistoryPage")),
  },
];
